import * as React from 'react'
import {
  WorkFeedLayout,
  WorkFeedWrapper,
} from 'components/home-page/work-feed/wrapper'
import { ActivityGrid } from 'components/activity-feed/grid/activity-grid'
import { ActivityFeed } from 'components/activity-feed'
import { Loader } from 'src/design-system'
import { WinActivityFeedVm } from './win-activity-feed-vm'
import { tabIdType } from './wins-page'

type WinsPageTabProps = {
  layout: WorkFeedLayout
  focusSkillIds: string[]
  tabId: tabIdType
  userId: string[]
  teamUserIds?: string[]
}

export const WinsPageTab = (props: WinsPageTabProps) => {
  const { layout, focusSkillIds, tabId, userId, teamUserIds } = props

  const [hasNextPage, setHasNextPage] = React.useState(false)
  const [pageNumber, setPageNumber] = React.useState(1)
  const [loading, setLoading] = React.useState(true)
  const [initialLoad, setInitialLoad] = React.useState(true) // New state variable

  const vm = React.useMemo(() => {
    return new WinActivityFeedVm(
      setHasNextPage,
      pageNumber,
      setPageNumber,
      tabId,
      userId,
      teamUserIds
    )
  }, [setHasNextPage, pageNumber, setPageNumber, tabId, userId, teamUserIds])

  React.useEffect(() => {
    const fetchActivities = async () => {
      setLoading(true)
      await vm.fetchActivities()
      setLoading(false)
      setInitialLoad(false) // Set initialLoad to false after the first load
    }

    fetchActivities()
  }, [vm, tabId, userId, teamUserIds, pageNumber])

  const addItemActiveTab = 'win'
  const addItemTitle = 'Add win '

  if (loading && initialLoad) {
    // Show loader only during the initial load
    return <Loader className="my-6" />
  }

  return (
    <>
      {layout === 'list' && (
        <WorkFeedWrapper layout={layout}>
          <ActivityFeed
            activities={vm.filteredActivities}
            focusSkillIds={focusSkillIds}
            hasNextPage={hasNextPage}
            onLoadMoreClick={vm.loadNextPage.bind(vm)}
            showFocusSkillName
            addItemActiveTab={addItemActiveTab}
            addItemTitle={addItemTitle}
          />
        </WorkFeedWrapper>
      )}
      {layout === 'grid' && (
        <WorkFeedWrapper layout={layout}>
          <ActivityGrid
            activities={vm.filteredActivities}
            storyMode="none"
            addItemActiveTab={addItemActiveTab}
            addItemTitle={addItemTitle}
            onSubmitStory={async () => {}}
            hasNextPage={hasNextPage}
            onLoadMore={vm.loadNextPage.bind(vm)}
          />
        </WorkFeedWrapper>
      )}
    </>
  )
}
